// Color swatch click → swap product card image
window.addEventListener('load', function () {
  document.querySelectorAll('.product-card__color-variant').forEach(function (variant) {
    variant.addEventListener('click', function () {
      var variantImage = variant.getAttribute('data-variant-image');
      var productCard = variant.closest('.product-card-wrapper');
      if (productCard) {
        var productImage = productCard.querySelector('.card__media img, .js-card-img');
        if (productImage) {
          productImage.src = variantImage;
          productImage.srcset = variantImage;
        }
      }
    });
  });
});

// Mega-menu childlink hover: highlight + swap collection image background
(function () {
  function init() {
    var lastHoveredLink;
    document.querySelectorAll('[id*=childlink]').forEach(function (container) {
      container.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('mouseover', function () {
          if (lastHoveredLink) {
            lastHoveredLink.classList.remove('list-menu__item-focused');
            lastHoveredLink.style.setProperty('--background-url', 'none');
          }
          link.classList.add('list-menu__item-focused');
          var imageUrl = link.dataset.collectionImg;
          if (imageUrl) {
            link.style.setProperty('--background-url', 'url(' + imageUrl + ')');
          }
          lastHoveredLink = link;
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
